module.exports = __webpack_public_path__ + "img/1c4eca7.png";